import SoundManager from '../../../../lib/html5-software-library/src/ranj/audio/SoundManager';

export default class AppSoundManager extends SoundManager {
    constructor() {
        super();
        this._soundConfig = null;
    };

    setConfig(soundConfig) {
        console.log("[AppSoundManager] Loading sound config");
        this._soundConfig = soundConfig;
    };

    playSound(id, completeHandler, errorHandler, delay, offset, loop, volume, pan, fadeInDuration, loopHandler) {
        if (this._soundConfig != null) {
            volume = this._soundConfig.getVolume(id);
        }
        console.log("[AppSoundManager].playSound " + id + " with volume" + volume + " mute " + this._mute);
        return super.playSound(id, completeHandler, errorHandler, delay, offset, loop, volume, pan, fadeInDuration, loopHandler);
    };
}